import React from 'react';
import Navigation from '../components/Navigation';
import ProgramManager from '../components/ProgramManager';
import './Programs.css';

const Home = () => {
  return (
    <div>
      <Navigation />
      <div className="content">
      <ProgramManager />
      </div>
    </div>
  );
};

export default Home;
